import {UserRole, DbUserRole} from '../types/enums';

/**
 * Handle server side and client side user role enum mapping
 * @param localRole user role in client enum
 */
export function localRoleToDbRole(localRole: UserRole): DbUserRole {
  switch (localRole) {
    case UserRole.Admin:
      return DbUserRole.Admin;

    case UserRole.Manager:
      return DbUserRole.Manager;

    case UserRole.Member:
      return DbUserRole.Member;

    case UserRole.Trial:
      return DbUserRole.Trial;

    case UserRole.Uploader:
      return DbUserRole.Uploader;

    case UserRole.Viewer:
      return DbUserRole.Viewer;
  }
}

/**
 * Handle server side and client side user role enum mapping
 * @param dbRole user role in server enum
 */
export function dbRoleToLocalRole(dbRole: DbUserRole): UserRole {
  switch (dbRole) {
    case DbUserRole.Admin:
      return UserRole.Admin;

    case DbUserRole.Manager:
      return UserRole.Manager;

    case DbUserRole.Member:
      return UserRole.Member;

    case DbUserRole.Trial:
      return UserRole.Trial;

    case DbUserRole.Uploader:
      return UserRole.Uploader;

    case DbUserRole.Viewer:
      return UserRole.Viewer;
  }
}
